module.exports = __webpack_public_path__ + "img/icon-zoom-plus.636ab4aa.svg";